export default __webpack_public_path__ + "static/media/sunflower.aff7f9dc.jpg";